module.exports = "/_next/static/images/avatar_Tomy-4d59462535ca67d07d868a57c3b33ab2.svg";